<template>
  <div class="site-setup-video-tutorials">
    <div class="d-flex flex-column tab-card-form">
      <div class="element-info">
        <div class="row align-items-center">
          <div v-if="this.mobile" class="col-sm-8">
            <div class="element-info-with-icon justify-content-center">
              <div class="element-info-text text-center">
                <h5 class="element-inner-header">Video Tutorials</h5>
                <div class="element-inner-desc">Here you can manage video tutorials.</div>
              </div>
            </div>
          </div>
          <div v-else class="col-sm-8">
            <div class="element-info-with-icon">
              <div class="element-info-icon">
                <fontAwesomeIcon :icon="['fas', 'video']" size="2x"/>
              </div>
              <div class="element-info-text ml-5">
                <h5 class="element-inner-header">Video Tutorials</h5>
                <div class="element-inner-desc">
                  Here you can manage video tutorials.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-box pb-3">
        <div class="project-head">
          <div class="project-title">
            <h5 v-if="!this.mobile" class="py-2">Video Tutorials</h5>
            <h5 v-else class="py-2 pt-4 text-center">Video Tutorials</h5>
          </div>
        </div>
        <div v-if="this.videos.available && this.videos.published" class="row">
          <div class="col-lg-6 col-sm-6">
            <div class="el-tablo centered padded-v">
              <div class="value">{{ this.videos.available.length }}</div>
              <div class="label">Available Videos</div>
            </div>
          </div>
          <div class="col-lg-6 col-sm-6">
            <div class="el-tablo centered padded-v">
              <div class="value text-primary">{{ this.videos.published.length }}</div>
              <div class="label">published videos</div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-box">
        <div class="project-head">
          <div class="project-title">
            <h5 v-if="!this.mobile" class="py-2">Available Video Tutorials</h5>
            <h5 v-else class="py-2 pt-4 text-center">Available Video Tutorials</h5>
          </div>
          <div class="project-description">
            Here we list all available video tutorials that are ready to be published but not yet visible to end users.
            Please specify role who will have access to this tutorial and press "Publish".
          </div>
        </div>
        <div v-if="!this.videos.available.length" class="row justify-content-center">
          <p class="text-muted">No available video tutorials found</p>
        </div>
        <div v-else>
          <b-table striped hover :items="this.videos.available" :fields="fields.available" show-empty>
            <template v-slot:cell(description)="data">
              <span><input class="form-control" type="text" v-model="data.item.description" /></span>
            </template>
            <template v-slot:cell(role)="data">
              <select class="custom-select" v-model="data.item.v3_level_id">
                <option v-for="r in roles" :value="r.id">{{ r.name }}</option>
              </select>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button size="sm" @click="preview(data.item)" class="mr-1">
                Preview
              </b-button>
              <b-button size="sm" @click="publish(data.item)" class="mr-1">
                Publish
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
      <div class="project-box mt-4">
        <div class="project-head">
          <div class="project-title">
            <h5 v-if="!this.mobile" class="py-2 element-header">Published Video Tutorials</h5>
            <h5 v-else class="py-2 pt-4 text-center">Published Video Tutorials</h5>
          </div>
          <div class="project-description">
            Here we list all published video tutorials that are already visible to end users.
          </div>
        </div>
        <div v-if="!this.videos.published.length" class="row justify-content-center">
          <p class="text-muted">No published video tutorials</p>
        </div>
        <div v-else>
          <b-table striped hover :items="this.videos.published" :fields="fields.published" show-empty>
            <template v-slot:cell(description)="data">
              <span><input class="form-control" type="text" v-model="data.item.description" /></span>
            </template>
            <template v-slot:cell(role)="data">
              <select class="custom-select" v-model="data.item.v3_level_id">
                <option v-for="r in roles" :value="r.id">{{ r.name }}</option>
              </select>
            </template>
            <template v-slot:cell(timestamp)="data">
              <span>{{ data.item.published_at | asDate }}</span>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button size="sm" @click="preview(data.item)" class="mr-1">
                Preview
              </b-button>
              <b-button size="sm" @click="unpublish(data.item)" class="mr-1">
                Un-publish
              </b-button>
              <b-button size="sm" @click="saveChanges(data.item)" class="mr-1">
                Save
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <AbsoluteNotification :notification="notification"/>
    <VideoTutorialPreviewModal :video="previewModalVideo" :base-url="baseUrl" />
    <div class="modal-backdrop show" v-if="overlayActive"></div>
  </div>
</template>

<script>
import axios from "../../axios";
import moment from "moment";
import VideoTutorialPreviewModal from "../../components/Help_Centre/VideoTutorialPreviewModal";
import AbsoluteNotification from "../../components/AbsoluteNotification";

export default {
  name: "SiteSetupVideoTutorials",
  components: { AbsoluteNotification, VideoTutorialPreviewModal },
  data() {
    return {
      videos: {
        published: [],
        available: [],
      },
      roles: [],
      fields: {
        published: [
          { key: 'basename', label: 'File name' },
          { key: 'description', label: 'Description' },
          { key: 'role', label: 'Role' },
          { key: 'timestamp', label: 'Published at' },
          { key: 'actions', label: 'Actions' }
        ],
        available: [
          { key: 'basename', label: 'File name' },
          { key: 'description', label: 'Description' },
          { key: 'role', label: 'Role' },
          { key: 'actions', label: 'Actions' }
        ],
      },
      overlayActive: false,
      previewModalVideo: null,
      baseUrl: null,
      notification: null,
    };
  },
  computed: {
    mobile: () => window.innerWidth <= 700
  },
  filters: {
    timestampToDate(timestamp) {
      return moment.unix(timestamp).format('DD/MM/YYYY, HH:mm:ss')
    }
  },
  methods: {
    loadTutorials() {
      axios().get("/getVideoTutorials").then(res => {
        if (res.data.roles) {
          this.roles = res.data.roles
          this.$store.commit("faqStore/setRoles", this.roles);
        }
        let preselectedRole = this.roles.length > 0 ? this.roles[0].id : null;
        if (res.data.available_videos) {
          this.videos.available = res.data.available_videos.map(v => {
            v.v3_level_id = preselectedRole;
            v.description = "";
            return v
          });
        }
        if (res.data.published_videos) {
          this.videos.published = res.data.published_videos
        }
        if (res.data.base_url) {
          this.baseUrl = res.data.base_url
        }
      }).catch(e => {
        console.error(e)
      })
    },
    preview(video) {
      this.overlayActive = true
      this.previewModalVideo = video
      this.$root.$emit('bv::show::modal', 'videoTutorialPreviewModal')
    },
    publish(video) {
      axios().post("/videoTutorialsPublish", video).then(() => {
        this.loadTutorials()
        this.notify("Changes saved successfully!");
      })
    },
    unpublish(video) {
      if (confirm("Are you sure you want to un-publish this tutorial? All information, including description, would be lost.")) {
        axios().post("/videoTutorialsUnpublish", video).then(() => {
          this.loadTutorials()
          this.notify("Changes saved successfully!");
        })
      }
    },
    saveChanges(video) {
      axios().post("/videoTutorialsUpdate", video).then(() => {
        this.notify("Changes saved successfully!");
      })
    },
    closeModal() {
      this.$root.$emit('bv::hide::modal', 'videoTutorialPreviewModal')
      this.overlayActive = false;
    },
    notify(text) {
      this.notification = text;
      setTimeout(() => {
        this.notification = null;
      }, 3000);
    }
  },
  created() {
    this.loadTutorials()
  }
}
</script>

<style lang="scss" scoped>
.site-setup-video-tutorials {
  margin-top: 2.5rem;
  .project-description {
    color: #999;
    font-weight: 300;
    font-size: 0.81rem;
    display: block;
  }
}

</style>
